import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { LocaleResolver } from "./i18n/LocaleResolver";
import { ThemeFontLock } from "./ThemeFontLock";
import { WidgetHeightLock } from "./WidgetHeightLock";
import "./styles.css";

const MOUNT_ID = "neelevat-quote-root";

// Self-mounting entry: find the mount element printed by the WordPress plugin
// (or the dev harness) and read its data attributes for configuration.
function mount() {
  const el = document.getElementById(MOUNT_ID);
  if (!el || el.dataset.nvMounted === "1") return;
  el.dataset.nvMounted = "1";

  const department = el.getAttribute("data-department") || "default";
  const fromMount = (el.getAttribute("data-api-base") || "").replace(/\/+$/, "");
  const fromEnv = import.meta.env.DEV ? (import.meta.env.VITE_API_BASE || "").replace(/\/+$/, "") : "";
  const apiBase = fromMount || fromEnv;
  const language = new LocaleResolver().resolve({
    hostname: window.location.hostname,
    queryLang: new URLSearchParams(window.location.search).get("lang"),
    htmlLang: document.documentElement.lang,
    mountLocale: el.getAttribute("data-locale"),
  });

  const heightLock = new WidgetHeightLock(el);
  heightLock.attach();
  new ThemeFontLock(el).attach();
  window.addEventListener("pagehide", () => heightLock.detach(), { once: true });

  createRoot(el).render(
    <StrictMode>
      <App department={department} apiBase={apiBase} language={language} />
    </StrictMode>,
  );
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", mount);
} else {
  mount();
}
